export const normalizeIndicators = (data) => {
  if (!data) return data
  const { indicators, indicator_count: count } = data
  const normalizedIndicators = indicators.map((indicator) => {
    const { attributed_associations: associations } = indicator

    const assocationsByType = associations?.reduce((acc, association) => {
      switch (association.type) {
        case 'threat-actor':
          acc.actorAssociations.push(association)
          break
        case 'campaign':
          acc.campaignAssociations.push(association)
          break
        case 'malware':
          acc.malwareAssociations.push(association)
          break
        case 'tool':
          acc.malwareAssociations.push(association)
          break
        default:
          break
      }
      return acc
    }, { actorAssociations: [], campaignAssociations: [], malwareAssociations: [], toolAssociations: [] })

    return {
      ...indicator,
      ...assocationsByType,
    }
  })

  return {
    indicators: normalizedIndicators,
    count,
  }
}

export const useIndicatorDataForGraph = (iocs) => {
  if (!iocs?.indicators) return
  const ips = iocs.indicators.filter(indicator => indicator.type === 'ipv4')
  const urls = iocs.indicators.filter(indicator => indicator.type === 'url')
  const files = iocs.indicators.filter(indicator => indicator.type === 'md5' || indicator.type === 'sha5' || indicator.type === 'sha256')
  const domains = iocs.indicators.filter(indicator => indicator.type === 'fqdn')
  return {
    ips,
    urls,
    files,
    domains
  }
}
